import {LOADING, SET_USER_SESSION,} from '../actions';
import {Auth} from 'aws-amplify';

import {API, graphqlOperation} from '@aws-amplify/api'
import config from '../../../aws-exports.js'

let originalFetch = require('isomorphic-fetch');
let fetch = require('fetch-retry')(originalFetch);

API.configure(config)

// TODO GLOBAL
export const restfulResources = {
    materials: '/materials',
    contracts: '/contracts',
    serialNumber: '/serial_number',
    swapMaterial: '/swap_material',
    order: '/order',
    orderDlApi: '/commondata/sap-order',
    bulkMaterials: '/materials/bulk',
    bulkContracts: '/contracts/bulk',
    placeholderMaterials: '/materials-placeholder',
    bulkPlaceholderMaterials: '/materials-placeholder/bulk',
    placeholderMaterial: '/material-placeholder',
    systems: '/systems',
    bulkSystems: '/systems/bulk',
    systemApplications: '/system_applications',
    bulkSystemApplications: '/system_applications/bulk',
    licenses: '/licenses',
    bulkLicenses: '/licenses/bulk',
    dataQualitySapOrders: '/data_quality_sap_order',
    hwsSnsTrail: '/hws_sns_trail',
    snSwap: '/materials/replace',
    materialSwap: '/materials/replace_entitlements',
    checkSnSwap: '/materials/check-replacement-validity',
    bulkReport: '/bulk_report',
    missingSnsStatus: '/missing_sns_status'
};


export async function getCognitoIdToken() {
    try {
        const session = await Auth.currentSession();
        return session.getIdToken().getJwtToken();
    } catch (error) {
        console.error('Error fetching auth token:', error);
        return null;
    }
}

async function performLogout() {
    console.error('Authentication failed - logging out user');
    localStorage.clear();
    await Auth.signOut();
    window.location.reload();
}

export function parseDynamoResult(data) {
    const parsedData = {};

    for (const key in data) {
        const valueObj = data[key];
        parsedData[key] = Object.values(valueObj)[0];
    }
    return parsedData;
}

export async function getFromServer(questObject, method="GET") {
    let restfulResource = questObject.resource;
    let params = questObject.params;
    let body = questObject.body;
    let responseCode = 0;

    const idToken = await getCognitoIdToken();
    if (!idToken) {
        await performLogout();
        throw new Error('Authentication failed - user logged out');
    }

    let _url;
    let _body;
    if (restfulResource === 'order' || restfulResource === 'serialNumber' || restfulResource === 'dataQualitySapOrders' || restfulResource === 'hwsSnsTrail' || restfulResource === 'bulkReport' || restfulResource === 'swapMaterial' || restfulResource === 'missingSnsStatus') {
        _url = process.env.REACT_APP_SE_PROXY_URL + restfulResources[restfulResource];
    }
    else {
        if (restfulResource === 'orderDlApi'){
            _url = process.env.REACT_APP_DL_API_URL + restfulResources[restfulResource];
        }
        else{
            _url = process.env.REACT_APP_SE_URL + restfulResources[restfulResource];

        }
    }

    if (params && params.id) {
        _url += '/' + params.id;
    } else if (params) {
        let keys = Object.keys(params);
        _url += '?';
        for (let i in keys) {
            let key = keys[i];
            let value = params[key];
            if (Array.isArray(value)) {
                for (let j in value) {
                    _url += '&' + key + '=' + value[j];
                }
            } else {
                _url += '&' + key + '=' + value;
            }
        }
    }
    if (method === "POST") {
        _body = JSON.stringify(body);
    }

    try {

        let reply = await fetch(_url, {
            method: method,
            body: _body,
            headers: {
                'Authorization': 'Bearer ' + idToken,
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
        })
            .then(function (response) {
                responseCode = response.status;
                console.log('middleware response', response);
                return response.json();

            })
            .then(function (json) {
                console.log("getFromServer then", json);
                return json;
            }).catch(err => {
                responseCode = 500;
                console.log('err', err);
                return { error: 'timeout', responseCode };
            });

        if (responseCode === 401 || responseCode === 403) {
            await performLogout();
            throw new Error('Authentication failed - user logged out');
        }

        reply.responseCode = responseCode;
        return reply;
    } catch (err) {
        console.error('getFromServer error:', err);
        throw err;
    }
}


export async function getFromGraphQlApi(query, body) {
    try {
        const args = {};
        for (const [key, value] of Object.entries(body)) {
            args[key] = value;
        }
        const response = await API.graphql(
            graphqlOperation(query, args, process.env.REACT_APP_GRAPHQL_KEY)
        );
        return response;
    } catch (err) {
        console.log(err);
    }
}


export function middleware({ dispatch }) {
    return function (next) {
        return async function (action) {
            switch (action.type) {
                case LOADING:
                    break;
                case SET_USER_SESSION:
                    break;
                default:
                    dispatch({ type: LOADING, loading: true });
                    break;

            };
            return next(action);
        }
    }
}

